var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offers-index-view"
  }, [(_vm.gridLoaded) ? _c('data-grid', {
    staticClass: "uk-margin-medium",
    attrs: {
      "columns": _vm.gridColumns,
      "is-loading": _vm.isLoading,
      "page-info": _vm.offers.pagination,
      "rows": _vm.offers.entries,
      "sort-info": _vm.offers.sort,
      "showActions": false,
      "sortable": ['productName']
    },
    on: {
      "sort": _vm.sortBy
    },
    scopedSlots: _vm._u([{
      key: "row",
      fn: function(props) {
        return [_c('td', [(props.row.product) ? _c('div', [_c('router-link', {
          attrs: {
            "to": {
              name: 'edit-offer-revision',
              params: {
                id: props.row.activeRevision.id
              }
            }
          }
        }, [_vm._v("\n            " + _vm._s(props.row.product.name) + "\n          ")])], 1) : _c('text-placeholder')], 1), _vm._v(" "), _c('td', {
          staticClass: "right"
        }, [_c('router-link', {
          staticClass: "uk-button",
          attrs: {
            "tag": "button",
            "to": {
              name: 'offer',
              params: {
                id: props.row.id
              }
            }
          }
        }, [_vm._v(" offer\n        ")])], 1)]
      }
    }])
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62ba4be8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/ActiveRevisions/OffersActiveRevisionsIndexView.vue
// module id = 2020
// module chunks = 0